<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title class="px-0 pb-0" style="font-weight: bold;  font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ดึงข้อมูลจากระบบซื้อขาย
      </v-card-title>
      <v-card-title class="px-0 pb-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ดึงข้อมูลจากระบบซื้อขาย
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" class="py-0 pr-2">
            <a-tabs @change="getGroupProduct">
              <a-tab-pane :key="1"><span slot="tab">สามารถดึงข้อมูลได้ <a-tag color="#6EC4D6" style="border-radius: 8px;">{{ countActive }}</a-tag></span></a-tab-pane>
              <a-tab-pane :key="2"><span slot="tab">ดึงข้อมูลแล้ว <a-tag color="#1AB759" style="border-radius: 8px;">{{ countInActive }}</a-tag></span></a-tab-pane>
            </a-tabs>
          </v-col>
          <v-col :cols="MobileSize ? 12 : IpadSize || IpadProSize ? 8 : 6" class="" :class="!MobileSize && !IpadSize  ? 'pl-0 pr-3 mb-3 pt-3' : 'mb-4 pt-3'" v-if="disableTable === false">
            <v-text-field v-model="search" placeholder="ค้นหารายการสินค้า" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="pt-2 pb-3" align="start">
            <v-row dense>
              <v-col :cols="MobileSize ? 12 : IpadSize ? 8 : 6" class="pt-5" v-if="disableTable === false">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-if="stateStatus === 1">รายการสินค้าที่สามารถดึงข้อมูลได้ทั้งหมด {{ showCount }} รายการ</span>
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="stateStatus === 2">รายการสินค้าที่ดึงข้อมูลแล้วทั้งหมด {{ showCount }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="disableTable === false">
            <v-data-table
            :headers="headers"
            :items="DataTable"
            :search="search"
            v-model="selected"
            item-key="product_id"
            :show-select="stateStatus === 1 ? true : false"
            @toggle-select-all="selectAllToggle"
            style="width:100%;"
            height="100%"
            :page.sync="page"
            @pagination="countRequest"
            no-results-text="ไม่พบรายการสินค้า"
            no-data-text="ไม่มีรายการสินค้า"
            :footer-props="{'items-per-page-text':'จำนวนแถว', 'items-per-page-options': [10, 20, 30, 40, 50, 100]}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="5"
            class="elevation-1 mt-4 fontTableData"
            >
              <template v-slot:[`item.data-table-select`]="{ isSelected, select}">
                <v-simple-checkbox :class="MobileSize ? 'pr-3' : ''" :value="isSelected" @input="select($event)" :ripple="false"></v-simple-checkbox>
              </template>
              <template v-slot:[`item.product_image`]="{ item }">
                <v-card width="100px" height="100px" class="d-flex ma-5 ml-0" :elevation="0">
                  <v-img :src="item.product_image" v-if="item.product_image !== ''"></v-img>
                  <v-img src="@/assets/NoImage.png" v-else></v-img>
                </v-card>
              </template>
            </v-data-table>
            <v-row no-gutters justify="end" align="center" class="mt-4 mb-5" v-if="stateStatus === 1">
              <v-btn @click="backtoMenu()" elevation="0" outlined color="#27AB9C" class="pl-8 pr-8" style="border: 1px solid #27AB9C; box-sizing: border-box; font-size: 16px; font-weight: 700; line-height: 24px;">ย้อนกลับ</v-btn>
              <v-btn :disabled="selected.length > 0 ? false : true" color="#27AB9C" elevation="0" class="ml-4 pl-10 pr-10" id="confirmcreateproduct" @click="confirm()" style="color: white; font-size: 16px; font-weight: 700; line-height: 24px;">ดึงข้อมูล</v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายการสินค้าจากระบบสั่งซื้อ</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- dialog comfirm -->
    <v-dialog  v-model="dialogConfirm" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">{{ title }}</font></span>
          <v-btn
            icon
            dark
            @click="cancel()"
            >
            <v-icon  color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/><br/>
        <v-card-text >
          <h4>คุณต้องการดึงข้อมูลจากระบบซื้อขายทั้งหมด {{selected.length}} รายการ</h4>
          <h4>ใช่หรือไม่ ?</h4>
        </v-card-text>
        <v-card-actions >
      <v-container >
        <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7" @click="cancel()">ยกเลิก</v-btn>
        <v-btn dense  color="#27AB9C" class="ml-4 pl-8 pr-8 white--text" @click="importProduct()">ตกลง</v-btn>
      </v-container>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog Delete Success -->
    <v-dialog v-model="dialogSuccess" persistent width="373">
        <v-card style="background: #FFFFFF; border-radius: 4px;" min-height="246px">
          <v-toolbar align="center" color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px">
              <font color="#27AB9C">{{title}}</font>
            </span>
            <v-btn icon dark @click="closeDialogConfirmDelete()">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-row justify="center" no-gutters dense>
                <v-col cols="12" align="center">
                  <v-img src="@/assets/ImageINET-Marketplace/ICONShop/successIcon.png" contain max-height="70" max-width="70"></v-img>
                </v-col>
                <v-col cols="12" align="center" class="mt-6">
                  <p style="font-weight: 500; font-size: 14px; line-height: 22px; color: color: #333333;" class="pt-0 mt-0">เสร็จสิ้น</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      userDetailSelling: '',

      stateStatus: 1,
      showCount: 0,
      countActive: 0,
      countInactive: 0,

      pageCount: 5,
      page: 1,
      itemsPerPage: 10,
      disableTable: false,
      selected: [],
      selectedProductID: [],
      search: '',
      headers: [
        { text: 'รูปสินค้า', value: 'product_image', filterable: true, width: '120px', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'รหัสสินค้่า', value: 'sku', filterable: true, width: '140px', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อสินค้า', value: 'product_name', filterable: true, sortable: false, width: '50px', class: 'backgroundTable fontTable--text' }
      ],
      productList: [],
      DataTable: [],

      title: '',
      dialogConfirm: false,
      dialogSuccess: false
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/ManageGroupCustomerMobile').catch(() => {})
      } else {
        this.$router.push('/Order/ManageGroupCustomer').catch(() => {})
      }
    },
    stateStatus (val) {
      if (val === 1) {
        this.DataTable = this.productList.not_import !== undefined ? this.productList.not_import : []
        this.showCount = this.DataTable.length
        if (this.DataTable.length === 0) {
          this.disableTable = true
        } else {
          this.disableTable = false
        }
      } else if (val === 2) {
        this.DataTable = this.productList.already_import !== undefined ? this.productList.already_import : []
        this.showCount = this.DataTable.length
        if (this.DataTable.length === 0) {
          this.disableTable = true
        } else {
          this.disableTable = false
        }
      }
    },
    selected () {
      console.log(this.selected)
    }
  },
  created () {
    this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = this.userDetailSelling.seller_shop_id
      }
      this.getData()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/ProductListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ProductList' }).catch(() => {})
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Parameter Missing') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Channel name is already exists.') {
        return ['มีชื่อกลุ่มลูกค้านี้ถูกใช้อยู่', 'warning']
      } else if (msg === 'Your channel can insert maximum 20 channel.') {
        return ['ไม่สามารถเพิ่มกลุ่มลูกค้าได้ เนื่องจากมีกลุ่มลูกค้าครบ 20 กลุ่มแล้ว', 'warning']
      } else if (msg === 'Channel name must not exceed 20 characters.') {
        return ['กรอกชื่อกลุ่มลูกค้าได้ไม่เกิน 20 ตัวอักษร', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    getGroupProduct (item) {
      this.stateStatus = item
      this.page = 1
    },
    async getData () {
      this.$store.commit('openLoader')
      this.countActive = 0
      this.countInActive = 0
      this.title = ''

      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListPanitProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczListPanitProduct
      if (response.message === 'Get list of products success.') {
        this.$store.commit('closeLoader')
        this.productList = response.data
        this.countActive = response.data.not_import.length
        this.countInActive = response.data.already_import.length
        if (this.stateStatus === 1) {
          this.DataTable = this.productList.not_import
          this.showCount = this.DataTable.length
          if (this.DataTable.length === 0) {
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        } else if (this.stateStatus === 2) {
          this.DataTable = this.productList.already_import
          this.showCount = this.DataTable.length
          if (this.DataTable.length === 0) {
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    selectAllToggle (props) {
      console.log('selectall', props)
      if (this.selected.length === this.DataTable.length) {
        this.selected = []
      } else {
        this.selected = this.DataTable
      }
      console.log(this.selected)
    },
    confirm () {
      this.dialogConfirm = true
    },
    async importProduct () {
      this.title = 'ดึงข้อมูลจากระบบซื้อขาย'
      var data = {
        seller_shop_id: this.seller_shop_id,
        select_product: this.selected
      }
      await this.$store.dispatch('actionsGraczImportPanitProduct', data)
      var response = await this.$store.state.ModuleGraczAdmin.stateGraczListPanitProduct
      console.log(response)
      if (response.result === 'SUCCESS' || response.message === 'Import products success.') {
        this.dialogConfirm = false
        this.dialogSuccess = true
        setTimeout(() => {
          this.getData()
          window.scrollTo(0, 0)
          this.dialogSuccess = false
        }, 1000)
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    cancel () {
      this.selected = []
      this.dialogConfirm = false
    }
  }
}
</script>
<style scoped>
.v-data-table /deep/ .v-data-table-header-mobile__wrapper {
  padding-right: 0px;
  display: flex;
  justify-content: end;
}
.theme--light.v-input {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>
<style lang="scss" scoped>
  ::v-deep .elevation-1 th:first-of-type {
    background-color: #E6F5F3;
  }
</style>
